import { Input } from './Input';
import { Select } from './Select';
import { Textarea } from './Textarea';
import type { WidgetConfiguration } from '../../types';

interface WidgetAppearanceFormProps {
  theme: WidgetConfiguration['theme'];
  primaryColor: string;
  position: WidgetConfiguration['position'];
  greetingMessage: string;
  onThemeChange: (value: WidgetConfiguration['theme']) => void;
  onPrimaryColorChange: (value: string) => void;
  onPositionChange: (value: WidgetConfiguration['position']) => void;
  onGreetingChange: (value: string) => void;
  showPreview?: boolean;
}

const THEME_OPTIONS = [
  { value: 'auto', label: 'Auto (match system)' },
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
];

const POSITION_OPTIONS = [
  { value: 'bottom-right', label: 'Bottom Right' },
  { value: 'bottom-left', label: 'Bottom Left' },
  { value: 'top-right', label: 'Top Right' },
  { value: 'top-left', label: 'Top Left' },
];

export function WidgetAppearanceForm({
  theme,
  primaryColor,
  position,
  greetingMessage,
  onThemeChange,
  onPrimaryColorChange,
  onPositionChange,
  onGreetingChange,
  showPreview = false,
}: WidgetAppearanceFormProps) {
  return (
    <div className="space-y-4">
      <Select
        label="Theme"
        value={theme}
        onChange={(e) => onThemeChange(e.target.value as WidgetConfiguration['theme'])}
        options={THEME_OPTIONS}
      />

      <div>
        <label className="block text-sm font-medium text-surface-700 mb-1">
          Primary Color
        </label>
        <div className="flex items-center gap-3">
          <input
            type="color"
            value={primaryColor}
            onChange={(e) => onPrimaryColorChange(e.target.value)}
            className="h-10 w-14 rounded border border-surface-300 cursor-pointer"
          />
          <Input
            type="text"
            value={primaryColor}
            onChange={(e) => {
              const v = e.target.value;
              if (/^#[0-9a-fA-F]{0,6}$/.test(v)) {
                onPrimaryColorChange(v);
              }
            }}
            className="w-28"
          />
          {showPreview && (
            <div
              className="w-10 h-10 rounded-full shadow-md border-2 border-white"
              style={{ backgroundColor: primaryColor }}
              title="Widget button preview"
            />
          )}
        </div>
      </div>

      <Select
        label="Widget Position"
        value={position}
        onChange={(e) => onPositionChange(e.target.value as WidgetConfiguration['position'])}
        options={POSITION_OPTIONS}
      />

      <Textarea
        label="Greeting Message"
        value={greetingMessage}
        onChange={(e) => onGreetingChange(e.target.value)}
        rows={2}
        placeholder="Welcome! How can I help you today?"
      />
    </div>
  );
}
